import { forwardRef } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import CloseButton from 'components/Common/CloseButton'
import Expander from 'components/utils/Expander'

const Root = styled.section`
  position: relative;
  border-top: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
`

const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  top: ${rem(8)};
  right: ${rem(8)};
  z-index: 1;
`

interface Props {
  className?: string
  isOpen: boolean
  onToggle?: () => void
  children: any
}

const PaneDetailsSection = forwardRef<HTMLDivElement, Props>(
  ({ className, isOpen, onToggle, children }: Props, ref) => (
    <Expander expanded={isOpen} ref={ref}>
      <Root className={className}>
        {onToggle &&
          <StyledCloseButton onClick={onToggle} />}
        {children}
      </Root>
    </Expander>
  ))

export default PaneDetailsSection
